import { Injectable } from '@angular/core'
import { Icon } from '@ftr/foundation'

@Injectable({
  providedIn: 'root',
})
export class IconUrlMapperService {
  private static URL_PATTERNS: { pattern: RegExp; icon: Icon }[] = [
    { pattern: /\/cases\/[a-z0-9-]+$/, icon: 'Case' },
    { pattern: /\/locations\/[a-z0-9-]+\/locations\/[a-z0-9-]+\/manage-courtroom/, icon: 'Door' },
    { pattern: /\/locations\/[a-z0-9-]+\/locations\//, icon: 'Courtroom' },
    { pattern: /\/locations/, icon: 'Courthouse' },
    { pattern: /\/departments\/[a-z0-9-]+$/, icon: 'Department' },
    { pattern: /\/cases\/[a-z0-9-]+\/hearing-playback\/[a-z0-9-]+$/, icon: 'Hearing' },
    { pattern: /\/recording-playback\b.*$/, icon: 'Recordings' },
    { pattern: /\/recordings\b.*$/, icon: 'Recordings' },
    { pattern: /\/audio-orders\b.*$/, icon: 'AudioOrder' },
    { pattern: /\/real-time-orders\b.*$/, icon: 'RealtimeOrder' },
    { pattern: /\/transcript-orders\b.*$/, icon: 'TranscriptOrder' },
    { pattern: /\/reports\b.*$/, icon: 'BarGraphVertical' },
    { pattern: /\/settings\/repositories\b.*$/, icon: 'TrmRepositories' },
    { pattern: /\/settings\/recorders\b.*$/, icon: 'Recorder' },
    { pattern: /\/settings\/users\b.*$/, icon: 'People' },
    { pattern: /\/settings\b.*$/, icon: 'Settings' },
    { pattern: /\/search\b.*$/, icon: 'Search' },
    { pattern: /\/calendar$/, icon: 'CourtroomCalendar' },
    { pattern: /\/judges$/, icon: 'Judge' },
    { pattern: /\/court-monitoring.*$/, icon: 'CourtMonitoring' },
  ]

  getIconForUrl(url: string): Icon {
    for (const mapping of IconUrlMapperService.URL_PATTERNS) {
      if (mapping.pattern.test(url)) {
        return mapping.icon
      }
    }
    return 'Favorites'
  }
}
